module.exports = __webpack_public_path__ + "img/right-arrow.0c2fade2.svg";